import Minze, { Attrs, EventListeners, MinzeElement, Reactive } from 'minze'
import { isMobile } from '../../../../modules/utils'
export interface LvcSearchMenu {
  isOpen: boolean
}
export interface LvcSearchMenu {
  dataElementLocation: string
}
export class LvcSearchMenu extends MinzeElement {
  attrs: Attrs = [['data-element-location', '']]
  reactive: Reactive = [['isOpen', false]]
  handleOnSearchMenuButtonClicked = () => {
    if (this.dataElementLocation === 'search-page' && !isMobile()) return
    this.isOpen = !this.isOpen
  }
  handleCloseButtonClicked = () => {
    if (this.dataElementLocation === 'search-page' && !isMobile()) return
    this.isOpen = false
  }
  onRender = () => {
    if (this.dataElementLocation === 'search-page' && !isMobile()) {
      this.isOpen = true
    }
    Minze.cast('lvc:search-menu-state-changed', {
      isOpen: this.isOpen,
    })
  }
  onHandleWindowResize = () => {
    if (isMobile()) return

    const isSearchPage = this.dataElementLocation === 'search-page'
    this.isOpen = isSearchPage && !isMobile()
  }

  html = () => {
    return /*html*/ `
        <div class="search-menu__close-button">${closeButton}</div>
        <lvc-search-bar-wrapper data-redirect-to-search="${
          this.dataElementLocation === 'search-page' ? false : true
        }"></lvc-search-bar-wrapper>
    `
  }
  css = () => `
    :host {
      display: ${this.isOpen ? 'block' : 'none'};
      width: 100vw;
      position: relative;
    }
    .search-menu__close-button {
      position: absolute;
      top: 10px;
      right: 14px;
      cursor: pointer;
      display: none;
      z-index: 1002;
    }
    @media screen and (max-width: 991px) {
      :host {
        position: fixed;
        height: calc(100dvh - 73px);
        z-index: 1001;
        background: white;
        bottom: 73px;
        left:0;
        padding-top: 2rem;
        border-bottom: 1px solid #e5e5e5;
    }
    .search-menu__close-button {
      display: block;
    }
  }
  `
  eventListeners?: EventListeners | undefined = [
    ['.search-menu__close-button', 'click', this.handleCloseButtonClicked],
    [window, 'lvc:search-menu-close-button-clicked', this.handleCloseButtonClicked],
    [window, 'lvc:search-menu-button-clicked', this.handleOnSearchMenuButtonClicked],
    [window, 'resize', this.onHandleWindowResize],
  ]
}

const closeButton = `
<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 7C12.1012 10.5797 20.3885 18.1369 20.7279 19.7279" stroke="#1E007D" stroke-width="1.35" stroke-linecap="round"/>
<path d="M20.7279 7C16.8177 10.7539 9.12616 18.2264 8 19.7279" stroke="#1E007D" stroke-width="1.35" stroke-linecap="round"/>
</svg>

`
